import React from 'react';
import { func, string } from 'prop-types';
import { Button } from '../../Atoms/Button';
import { Artworks } from '../..';
import { ContentWrapper, TitleWrapper, SubtitleWrapper, SupportArtwork } from './NotFound.styles';
export const NotFound = _ref => {
  let {
    linkCallback,
    buttonText
  } = _ref;
  const {
    campfireGoneOut: ArtworkCampfireGoneOut
  } = Artworks;
  return /*#__PURE__*/React.createElement(ContentWrapper, null, /*#__PURE__*/React.createElement(SupportArtwork, null, /*#__PURE__*/React.createElement(ArtworkCampfireGoneOut, null)), /*#__PURE__*/React.createElement(TitleWrapper, null, "Oh, shoot!"), /*#__PURE__*/React.createElement(SubtitleWrapper, null, "Sorry, but the page you\u2018re looking for doesn\u2018t exist."), linkCallback ? /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "large",
    onClick: linkCallback
  }, buttonText || 'Back to Profile') : /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "large",
    href: "/"
  }, buttonText || 'Back to Paddl'));
};
NotFound.propTypes = {
  linkCallback: func,
  buttonText: string
};
NotFound.defaultProps = {
  linkCallback: undefined,
  buttonText: ''
};